import {createAsyncThunk, createReducer} from '@reduxjs/toolkit';

import {ENDPOINTS} from 'constants/endpoints';

import {apiConfig} from 'libs/api/api';

import {getQuote} from '../../reducers/quoteItems/quoteItems';

type ErrorReturnType = {
    code: number;
    message: string;
};

type UhcDataType = {
    firstName: string;
    lastName: string;
    isFlatRate: boolean;
    allowance: number;
    copay: number;
    status: 'fulfilled' | 'pending' | 'rejected';
    errors: Array<ErrorReturnType>;
};

export type RejectedUhcAllowanceActionType = {
    response: {data: {messages: {error: {message: string}[]}}};
};

/**
 * Requests to change cart item with applied uhc allowance
 * @param {string} id - cart item id
 */
export const changeUhcAllowanceItem = createAsyncThunk<
    UhcDataType,
    number | string,
    {rejectValue: RejectedUhcAllowanceActionType}
>('CHANGE_UHC_ALLOWANCE_ITEM', async (id, {rejectWithValue}) => {
    try {
        return await apiConfig.instanceGusaBackend.request({
            data: {
                id,
            },
            method: 'put',
            url: ENDPOINTS.UHC_CHANGE_ALLOWANCE_ITEM,
        });
    } catch (e) {
        return rejectWithValue(e);
    }
});

/**
 * uhc change allowance item reducer
 */
export const applyingAllowance = createReducer<boolean>(false, builder =>
    builder
        .addCase(getQuote.fulfilled, () => false)
        .addCase(changeUhcAllowanceItem.rejected, () => false)
        .addCase(changeUhcAllowanceItem.pending, () => true),
);
